let cookieBox = null;
let cookieButtons = null;

function setConsentCookie(value) {
    document.cookie = `cookie-consent=${value}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
}

async function recordConsent(type, isGranted, consentScope) {
    const response = await fetch('/api/consent/record', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]')?.value || ''
        },
        body: JSON.stringify({
            type: type,
            isGranted: isGranted,
            consentScope: consentScope,
            policyVersion: 'cookies-v1.3'
        })
    });

    if (!response.ok) {
        throw new Error(`Consent record failed for ${type}`);
    }
}

async function executeCodes() {
    cookieBox = document.querySelector('.cookie-consent');
    cookieButtons = document.querySelectorAll('[data-cookie-button]');
    if (!cookieBox) {
        return;
    }

    try {
        const response = await fetch('/api/consent/check/analytics');
        if (response.ok) {
            const result = await response.json();
            if (result.hasConsent) {
                return;
            }
        }
    } catch (error) {
    }

    cookieBox.classList.add('show');

    cookieButtons.forEach((button) => {
        button.addEventListener('click', async () => {
            cookieBox.classList.remove('show');

            const acceptAll = button.id === 'cookie-accept';

            try {
                if (acceptAll) {
                    await Promise.all([
                        recordConsent('technical', true, 'essential'),
                        recordConsent('analytics', true, 'analytics'),
                        recordConsent('marketing', true, 'marketing')
                    ]);
                    setConsentCookie('all');
                } else {
                    await Promise.all([
                        recordConsent('technical', true, 'essential'),
                        recordConsent('analytics', false, 'analytics'),
                        recordConsent('marketing', false, 'marketing')
                    ]);
                    setConsentCookie('essential');
                }
            } catch (error) {
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', executeCodes);
